/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-tab-button {
  cursor: pointer;
  display: block;
  height: 36px;
}
.ux-tab-button + .ux-tab-button {
  margin-left: 5px;
}
.ux-tab-button__label {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  align-items: center;
  color: #131313;
  cursor: pointer;
  display: inline-flex;
  flex-flow: row nowrap;
  font-size: 13px;
  height: 100%;
  justify-content: center;
  line-height: 1;
  margin-left: 15px;
  margin-right: 15px;
  padding: 0;
  position: relative;
  text-rendering: optimizelegibility;
  text-transform: uppercase;
  transition: color 250ms ease-in-out;
}
@media screen and (width >= 769px) {
  .ux-tab-button__label {
    margin-left: 20px;
    margin-right: 20px;
  }
}
.ux-tab-button__label:hover {
  color: #595959;
}
.ux-tab-button.is-active {
  background-color: #285172;
}
.ux-tab-button.is-active .ux-tab-button__label {
  color: #fff;
}
.ux-tab-button--folder {
  background: #c3cfd6;
  height: auto;
  padding: 10px 30px;
}
@media only screen and (min-width: 1920px) {
  .ux-tab-button--folder {
    padding: 15px 30px;
  }
}
.ux-tab-button--folder + .ux-tab-button--folder {
  margin-left: 10px;
}
.ux-tab-button--folder .ux-tab-button__label {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #131313;
  text-transform: none;
  font-size: 16px;
  margin: 0;
}
@media only screen and (min-width: 1920px) {
  .ux-tab-button--folder .ux-tab-button__label {
    font-size: 18px;
  }
}
.ux-tab-button--folder .ux-tab-button__label:hover {
  color: #131313;
}
.ux-tab-button--folder:hover {
  background-color: #899fb2;
}
.ux-tab-button--folder.is-active {
  background: #fff;
}
.ux-tab-button--folder.is-active .ux-tab-button__label {
  color: #131313;
}